<template>
  <div class="z-20 left-0 bottom-0 fixed w-screen bg-EXPONDO-grey-5 shadow-thin flex justify-center">
    <div
      class="lg:max-w-screen-2xl py-2 px-4 w-full
        flex items-center justify-center lg:justify-between gap-4"
    >
      <p class="desktop-only text-lg font-bold">
        {{ productTitle }}
      </p>
      <div>
        <ProductPricing
          :full-product-price="fullProductPrice"
          :discounted-price="discountedPrice"
          is-active-product
        />
        <PriceDisclaimer
          :is-discounted="isDiscounted"
          :last30-days-price="last30DaysPrice"
          />
      </div>
      <AddToCart
        :product="product"
        :product-adjusted-for-cart="productAdjustedForCart"
        :has-quantity-selector="false"
        :is-floating-add-to-cart="true"
        class="lg:w-1/4"
      />
    </div>
  </div>
</template>

<script lang="ts">

import { defineAsyncComponent } from 'vue';


import type { ProductVariant } from '~~/types/commercetools';
import { productGetters } from '~/utils/ct';

export default defineComponent({
  name: 'FloatingAddToCart',
  components: {
    ProductPricing: defineAsyncComponent(
      () => import('~/components/molecules/Product/ProductPricing/ProductPricing.vue'),
    ),
    PriceDisclaimer: defineAsyncComponent(
      () => import('~/components/molecules/Product/PriceDisclaimer.vue'),
    ),
  },
  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
    productAdjustedForCart: {
      type: Object,
      required: true,
    },
  },
  setup(props) {

    const { product } = toRefs(props);

    const { getPriceInformation } = useProductPrice();
    const {
      fullProductPrice,
      discountedPrice,
      isDiscounted,
      last30DaysPrice,
    } = getPriceInformation(product);

    const productTitle = computed(() => productGetters.getName(product.value));

    return {
      fullProductPrice,
      discountedPrice,
      isDiscounted,
      last30DaysPrice,
      productTitle,
    };

  },
});


</script>
